import InputPasswordField from './InputPasswordField';

export default InputPasswordField;
